export default "__VITE_ASSET__BBm4FDkj__"